// @flow

import createMuiTheme from 'material-ui/styles/createMuiTheme'

const breakpoints = {
  sm: '@media (min-width: 600px)',
  md: '@media (min-width: 960px)',
  lg: '@media (min-width: 1280px)',
  xl: '@media (min-width: 1920px)',
}

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#0071BC',
    },
  },
  typography: {
    fontSize: 16,
    fontWeightRegular: '300',
    display2: {
      fontSize: '2rem',
      fontFamily: 'Montserrat, sans-serif',
      lineHeight: '1.25',
      [breakpoints.md]: {
        fontSize: '2.75rem',
      },
      [breakpoints.lg]: {
        fontSize: '3.75rem',
      },
    },
    headline: {
      fontFamily: 'Montserrat, sans-serif',
      fontSize: '2rem',
      fontWeight: '300',
      textAlign: 'center',
      [breakpoints.md]: {
        fontSize: '3rem',
      },
      [breakpoints.lg]: {
        fontSize: '3.75rem',
      },
    },
    subheading: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: '1rem',
      textAlign: 'center',
      [breakpoints.sm]: {
        fontSize: '1.25rem',
      },
      [breakpoints.lg]: {
        fontSize: '1.5rem',
      },
    },
    body1: {
      fontSize: '1rem',
      [breakpoints.sm]: {
        fontSize: '1.25rem',
      },
      [breakpoints.md]: {
        fontSize: '1.25rem',
      },
    },
    body2: {
      fontSize: '1rem',
      [breakpoints.md]: {
        fontSize: '1rem',
      },
    },
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: 0,
      },
    },
  },
})

export default theme



// WEBPACK FOOTER //
// ./src/styles/theme.js